// extracted by mini-css-extract-plugin
export default {"headers":"Layouts_headers__7Gs8a","pad":"Layouts_pad__qmyhe","overflow":"Layouts_overflow__5DZqV","credit":"Layouts_credit__QJPc6"};